var map = {
	"./eight-pcs-box.png": 41,
	"./eight-pcs-box__square.png": 42,
	"./facebook-icon.png": 43,
	"./features.png": 22,
	"./five-pcs-box.png": 44,
	"./five-pcs-box__square.png": 45,
	"./gift-set.png": 46,
	"./handmade.png": 23,
	"./insta-icon.png": 47,
	"./logo-no-background.png": 16,
	"./pcs-array.png": 24,
	"./samurai.png": 25,
	"./tiktok-icon.png": 48
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40;